import log from "loglevel"

export const createLogger = (name) => log.getLogger(name)
